import DutyStatusLog from "../../model/DutyStatusLog";
import { IDailyOdometer } from "../../model/DutyStatusLogs";
import { type IViolation } from "hos-tools";

export interface IDutyStatusLogStore {
    userId: string;
    logs: IIdDictionary<DutyStatusLog>;
}

export enum UserHosLogActionTypes {
    SET_USER_HOS_LOGS = "SET_USER_HOS_LOGS",
    REMOVE_USER_HOS_LOGS = "REMOVE_USER_HOS_LOGS",
    CLEAR_USER_HOS_LOGS = "CLEAR_USER_HOS_LOGS"
}

export enum SystemHosLogActionTypes {
    SET_SYSTEM_HOS_LOGS = "SET_SYSTEM_HOS_LOGS",
    CLEAR_SYSTEM_HOS_LOGS = "CLEAR_SYSTEM_HOS_LOGS"
}

export interface IHistoricalDayEntry {
    loadedAt: number;
    hosLogs: DutyStatusLog[];
    systemLogs: DutyStatusLog[];
    violations: IViolation[];
    // Per-device odometer start/end bounds for this day, computed at load time. Cached here (rather
    // than in the shared `dailyOdometer` store) because sync replaces that store wholesale and only
    // computes in-window days — see IHistoricalDayEntry usage in historicalDayLoader. Optional for
    // backward-compat with entries cached before odometer support.
    odometer?: IDailyOdometer;
}

export type IHistoricalDayTracker = IIdDictionary<IIdDictionary<IHistoricalDayEntry>>;

export enum HistoricalDayActionTypes {
    TRACK_HISTORICAL_DAY = "TRACK_HISTORICAL_DAY",
    UNTRACK_HISTORICAL_DAY = "UNTRACK_HISTORICAL_DAY",
    CLEAR_TRACKED_DAYS = "CLEAR_TRACKED_DAYS",
    CLEAR_USER_TRACKED_DAYS = "CLEAR_USER_TRACKED_DAYS"
}